import React from 'react';
import { Icon } from './Icon.js';
export const IconBadgeCheck2 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M12.5 2L15.5 4.5H19L19.5 5V9L22 11.5V12.5L19.5 15V19L19 19.5H15.5L12.5 22H11.5L8.5 19.5H5L4.5 19V15L2 12.5V11.5L4.5 9V5L5 4.5H8.5L11.5 2H12.5Z", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M8.5 12.5L11 15L16 10", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconBadgeCheck2.js.map